import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PackageX, ChevronDown, ChevronUp } from 'lucide-react';
import axiosInstance from '../../api/axios';
import { imgVariant } from '../../utils/imgUrl';

export const OutOfStockWidget = () => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axiosInstance.get('/orders/admin/out-of-stock').then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || data.count === 0) return null;

  return (
    <div className="mb-5 border border-red-200 bg-red-50" data-testid="out-of-stock-widget">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-2 p-3 text-left"
        data-testid="out-of-stock-toggle"
      >
        <span className="flex items-center gap-2 text-sm text-red-800">
          <PackageX className="h-4 w-4" />
          <strong data-testid="out-of-stock-count">{data.fully_out}</strong> Artikel ausverkauft
          {data.count > data.fully_out && <span>· {data.count - data.fully_out} mit ausverkauften Farben</span>}
          <span className="text-red-600/80">– Kunden können diese nicht bestellen</span>
        </span>
        {open ? <ChevronUp className="h-4 w-4 text-red-700" /> : <ChevronDown className="h-4 w-4 text-red-700" />}
      </button>
      {open && (
        <div className="border-t border-red-200 bg-white max-h-72 overflow-y-auto">
          {data.products.map((p) => (
            <div key={p.id} className="flex items-center gap-3 px-3 py-2 border-b border-red-50 last:border-0" data-testid={`oos-item-${p.id}`}>
              <div className="w-9 h-9 bg-[#FAF5EE] flex-shrink-0 overflow-hidden">
                {p.image && <img src={imgVariant(p.image, { w: 80 })} alt="" className="w-full h-full object-cover" loading="lazy" />}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-[#5D4E3C] truncate">{p.name}</p>
                <p className="text-[11px] text-red-700">
                  {p.fully_out ? 'Ausverkauft' : `Ausverkauft in: ${p.oos_variants.join(', ')}`}
                </p>
              </div>
            </div>
          ))}
          <div className="p-2 text-right">
            <Link to="/admin/inventory" className="text-xs font-medium text-[#8B7355] hover:underline" data-testid="oos-to-inventory">
              Lagerbestand auffüllen →
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};
